import { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { config } from '../../app-confi/app-config';

const ProjectConf = ({ currentProject, onChangeProject }) => {

    const [projectName, setProjectName] = useState('');
    const [nameError, setNameError] = useState<{
        error: boolean,
        message: string
    }>({ error: undefined, message: undefined });

    const validateName = (name: string) => {
        let valid = true;
        if (name.length < 1) {
            valid = false;
            setNameError({ error: true, message: 'Project naam heeft geen karakters.' })
        } else if (name.length > config.shortFieldSize) {
            valid = false;
            setNameError({ error: true, message: `Project naam heeft meer dan ${config.shortFieldSize} karakters.` })
        } else {
            setNameError({ error: false, message: undefined })
        }
        return valid;
    }

    useEffect(() => {
        let valid = validateName(currentProject.name);
        if (valid) {
            setProjectName(currentProject.name);
        }
    }, [currentProject.name])

    const changeProjectName = (name: string) => {
        validateName(name);
        setProjectName(name);
    }

    return currentProject && (
        <div className="group" data-testid="ProjectConf">
            <h2>Project Wijzigen</h2>
            <TextField
                error={nameError.error}
                id="standard-read-only-input"
                label="Project Naam"
                onBlur={() => {
                    let valid = validateName(projectName);
                    if (valid) {
                        onChangeProject({ ...currentProject, name: projectName })
                    }
                }
                }
                value={projectName}
                onChange={(e) => changeProjectName(e.target.value)}
                variant="standard"
                helperText={nameError.message}
            />
        </div>
    )
};

export default ProjectConf;
